$(document).ready(function() {
	document.querySelectorAll('[data-job-apply-toggle]').forEach((button) => {
		const detailsId = button.getAttribute('aria-controls');
		const details = detailsId ? document.getElementById(detailsId) : null;

		if (!details) {
			return;
		}

		button.addEventListener('click', () => {
			const isExpanded = button.getAttribute('aria-expanded') === 'true';

			button.setAttribute('aria-expanded', String(!isExpanded));
			details.hidden = isExpanded;
		});
	});
});
